<header class="header" [class.scrolled]="isScrolled">
    <div class="header-container page-container">
        <div class="logo">
            <img
                [routerLink]="[RouterPath.HOME]"
                src="assets/branding/logo-datacore.svg"
                alt="DATACORE Logo"
            />
        </div>

        <nav class="nav">
            <ul class="main-menu">
                <li
                    class="dropdown"
                    (mouseenter)="setPanel('productDropdown', true)"
                    (mouseleave)="onMouseLeave('productDropdown')"
                    (click)="togglePanel('productDropdown', $event)"
                >
                    <div class="menu-item">
                        <span>{{ 'header.product' | translate }}</span>
                        <img src="assets/home/arrow-down-icon.png" alt="" width="12" height="12" />
                    </div>
                    <ul class="submenu" *ngIf="productDropdownOpen">
                        <li [routerLink]="[RouterPath.SERVICES]" (click)="productDropdownPinned = true">
                            {{ 'header.products.services' | translate }}
                        </li>
                        <li [routerLink]="[RouterPath.GET_DATA, RouterPath.DATA_DOMAINS]" (click)="productDropdownPinned = true">
                            {{ 'header.products.dataProduct' | translate }}
                        </li>
                        <li *ngIf="hpcEnabled" [routerLink]="[RouterPath.HPC]" (click)="productDropdownPinned = true">
                            {{ 'header.products.hpc' | translate }}
                        </li>
                    </ul>
                </li>
                <li [routerLink]="[RouterPath.DEMO, RouterPath.DATA_DOMAINS]" (click)="closeAllPanels()">
                    {{ 'header.demo' | translate }}
                </li>
                <li
                    class="dropdown"
                    (mouseenter)="setPanel('newsDropdown', true)"
                    (mouseleave)="onMouseLeave('newsDropdown')"
                    (click)="togglePanel('newsDropdown', $event)"
                >
                    <div class="menu-item">
                        <span>{{ 'header.new' | translate }}</span>
                        <img src="assets/home/arrow-down-icon.png" alt="" width="12" height="12" />
                    </div>
                    <ul class="submenu" *ngIf="newsDropdownOpen">
                        <li>
                            <a [href]="getBlogUrl()" (click)="newsDropdownPinned = true">
                                {{ 'header.news.blog' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [href]="getNewsUrl()" (click)="newsDropdownPinned = true">
                                {{ 'header.news.news' | translate }}
                            </a>
                        </li>
                    </ul>
                </li>
                <li [routerLink]="[RouterPath.ABOUT]" (click)="closeAllPanels()">
                    {{ 'header.about' | translate }}
                </li>
                <li [routerLink]="[RouterPath.PRICING]" (click)="closeAllPanels()">
                    {{ 'header.pricing' | translate }}
                </li>
            </ul>
        </nav>

        <div class="actions">
            <!-- <img src="assets/home/sms-edit.png" /> -->
            <div class="lang-select" (mouseenter)="setPanel('langDropdown', true)" (mouseleave)="onMouseLeave('langDropdown')">
                <div class="lang-btn" (click)="togglePanel('langDropdown', $event)">
                    <span>{{ langDisplay }}</span>
                    <img src="assets/home/arrow-down-icon.png" alt="" width="16" height="16" />
                </div>

                <ul class="lang-menu" *ngIf="langDropdownOpen">
                    <li
                        (click)="selectLanguage('VIE')"
                        [class.selected]="langDisplay === 'VIE'"
                    >
                        VIE
                        <span *ngIf="langDisplay === 'VIE'" class="check"
                            >✔</span
                        >
                    </li>
                    <li
                        (click)="selectLanguage('ENG')"
                        [class.selected]="langDisplay === 'ENG'"
                    >
                        ENG
                        <span *ngIf="langDisplay === 'ENG'" class="check"
                            >✔</span
                        >
                    </li>
                </ul>
            </div>
            <button *ngIf="!token" class="login-btn" [disabled]="loginLoading" (click)="login()">
                <span *ngIf="loginLoading" class="login-spinner"></span>
                {{ 'header.login' | translate }}
            </button>
            <app-notification
                *ngIf="token"
                [setPanelEvent]="notificationPanelEvent"
                (panelClick)="closeAllPanels()"
            ></app-notification>
            <div
                *ngIf="token"
                class="profile-menu-container"
                (mouseenter)="setPanel('profileDropdown', true)"
                (mouseleave)="onMouseLeave('profileDropdown')"
            >
                <img
                    class="menu-item"
                    src="assets/home/profile.png"
                    alt="Profile menu"
                    width="30"
                    height="30"
                    (click)="togglePanel('profileDropdown', $event)"
                />
                <div class="dropdown-profile-menu" *ngIf="profileDropdownOpen">
                    <div class="menu-item selected" (click)="profile()">
                        <i class="icon user"></i>
                        <span>{{ 'header.myAccount' | translate }}</span>
                    </div>
                    <div class="menu-item" (click)="orderHistory()">
                        <i class="icon cart"></i>
                        <span>{{ 'header.orderHistory' | translate }}</span>
                    </div>
                    <div class="menu-item" (click)="logout()">
                        <i class="icon logout"></i>
                        <span>{{ 'header.logout' | translate }}</span>
                    </div>
                </div>
            </div>
            <button class="mobile-menu-btn" (click)="togglePanel('mobileNav', $event)" type="button" aria-label="Toggle menu">
                <img src="assets/icons/icon-menu.svg" alt="" width="24" height="24" />
            </button>
        </div>
    </div>
    <div class="mobile-menu-backdrop" [class.visible]="mobileNavOpen" (click)="togglePanel('mobileNav', $event)"></div>
    <nav class="mobile-menu" [class.open]="mobileNavOpen">
        <div class="menu-header">
            <img
                src="assets/header/close-circle.png"
                alt="Close menu"
                width="24"
                height="24"
                (click)="togglePanel('mobileNav', $event)"
            />
        </div>

        <ul class="menu-list">
            <li
                *ngIf="token"
                class="has-submenu"
                (click)="togglePanel('profile', $event)"
            >
                <div class="menu-item">
                    <span class="avatar-container">
                        <img
                            class="avatar"
                            src="assets/header/profile-circle.png"
                            alt=""
                            width="24"
                            height="24"
                        />
                        <span>{{ 'header.myAccount' | translate }}</span>
                    </span>
                    <img
                        class="arrow"
                        src="assets/header/arrow-down.png"
                        alt=""
                        width="16"
                        height="16"
                        [class.open]="mobileNavDropdownOpen.profile"
                    />
                </div>
                <ul class="submenu" [class.show]="mobileNavDropdownOpen.profile">
                    <li
                        [routerLink]="[RouterPath.PROFILE, RouterPath.ORDER_HISTORY]"
                        (click)="setPanel('mobileNav', false)"
                    >
                        {{ 'header.orderHistory' | translate }}
                    </li>
                    <li
                        [routerLink]="[RouterPath.PROFILE, RouterPath.CHANGE_PASSWORD]"
                        (click)="setPanel('mobileNav', false)"
                    >
                        {{ 'header.changePassword' | translate }}
                    </li>
                    <li
                        [routerLink]="[RouterPath.PROFILE, RouterPath.API_KEYS]"
                        (click)="setPanel('mobileNav', false)"
                    >
                        {{ 'header.apiKeys' | translate }}
                    </li>
                    <!-- <li
                        (click)="logout()"
                    >
                        {{ 'header.logout' | translate }}
                    </li> -->
                </ul>
            </li>
            <!-- Product -->
            <li
                class="has-submenu"
                (click)="togglePanel('product', $event)"
            >
                <div class="menu-item">
                    <span>{{ 'header.product' | translate }}</span>
                    <img
                        class="arrow"
                        src="assets/header/arrow-down.png"
                        alt=""
                        width="16"
                        height="16"
                        [class.open]="mobileNavDropdownOpen.product"
                    />
                </div>
                <ul class="submenu" [class.show]="mobileNavDropdownOpen.product">
                    <li [routerLink]="[RouterPath.SERVICES]" (click)="setPanel('mobileNav', false)">
                        {{ 'header.products.services' | translate }}
                    </li>
                    <li [routerLink]="[RouterPath.GET_DATA, RouterPath.DATA_DOMAINS]" (click)="setPanel('mobileNav', false)">
                        {{ 'header.products.dataProduct' | translate }}
                    </li>
                    <li *ngIf="hpcEnabled" [routerLink]="[RouterPath.HPC]" (click)="setPanel('mobileNav', false)">
                        {{ 'header.products.hpc' | translate }}
                    </li>
                </ul>
            </li>
            <li [routerLink]="[RouterPath.DEMO, RouterPath.DATA_DOMAINS]" (click)="setPanel('mobileNav', false)">
                {{ 'header.demo' | translate }}
            </li>
            <li class="has-submenu" (click)="togglePanel('news', $event)">
                <div class="menu-item">
                    <span>{{ 'header.new' | translate }}</span>
                    <img
                        class="arrow"
                        src="assets/header/arrow-down.png"
                        alt=""
                        width="16"
                        height="16"
                        [class.open]="mobileNavDropdownOpen.news"
                    />
                </div>
                <ul class="submenu" [class.show]="mobileNavDropdownOpen.news">
                    <li>
                        <a [href]="getNewsUrl()" (click)="setPanel('mobileNav', false)">{{ 'header.news.news' | translate }}</a>
                    </li>
                    <li>
                        <a [href]="getBlogUrl()" (click)="setPanel('mobileNav', false)">{{ 'header.news.blog' | translate }}</a>
                    </li>
                </ul>
            </li>
            <li [routerLink]="[RouterPath.ABOUT]" (click)="setPanel('mobileNav', false)">
                {{ 'header.about' | translate }}
            </li>
            <li [routerLink]="[RouterPath.PRICING]" (click)="setPanel('mobileNav', false)">
                {{ 'header.pricing' | translate }}
            </li>
        </ul>

        <ul class="menu-list menu-actions">
            <li class="has-submenu" (click)="togglePanel('lang', $event)">
                <div class="menu-item">
                    <span>{{ langDisplay }}</span>
                    <img
                        class="arrow"
                        src="assets/header/arrow-down.png"
                        alt=""
                        width="16"
                        height="16"
                        [class.open]="mobileNavDropdownOpen.lang"
                    />
                </div>
                <ul class="submenu" [class.show]="mobileNavDropdownOpen.lang">
                    <li (click)="selectLanguage('ENG')">ENG</li>
                    <li (click)="selectLanguage('VIE')">VIE</li>
                </ul>
            </li>
            <li *ngIf="token" class="logout-container" (click)="logout()">
                <img src="assets/header/logout.png" alt="" width="20" height="20" />
                {{ 'header.logout' | translate }}
            </li>
        </ul>

    <button *ngIf="!token" class="login-button" [disabled]="loginLoading" (click)="login()">
        <span *ngIf="loginLoading" class="login-spinner"></span>
        {{ 'header.login' | translate }}
    </button>
    </nav>
</header>
<app-login-modal
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (openSignUp)="showSignup = true"
    (openForgotPassword)="showForgotPassword = true"
    (switchToSetProfile)="showSetupProfile = true"
></app-login-modal>
<app-signup-modal
    *ngIf="showSignup"
    (closed)="showSignup = false"
    (switchToLoginEvent)="showLogin = true"
    (switchToOtp)="showOtp = true"
    (switchToSetProfile)="showSetupProfile = true"
></app-signup-modal>
<app-verify-otp-modal
    *ngIf="showOtp"
    (closed)="showOtp = false"
    (back)="showSignup = true"
    (showLogin)="showLogin = true"
></app-verify-otp-modal>
<app-forgot-password-modal
    *ngIf="showForgotPassword"
    (closed)="showForgotPassword = false"
    (showLogin)="showLogin = true"
></app-forgot-password-modal>
<app-setup-profile-modal
    *ngIf="showSetupProfile"
    (closed)="showSetupProfile = false">
</app-setup-profile-modal>
<app-confirm-modal
    *ngIf="confirmModalService.visible"
    [data]="confirmModalService.data"
    (closed)="confirmModalService.close($event)">
</app-confirm-modal>
